/**
 * Sunrise/Sunset condition node definition.
 */

import type { NodeDefinition } from '../types';
import type { FlowNode } from '../../../types/flow-types';
import { createSunriseSunsetConditionFromFlow } from '../../../converters/helpers/sunrise-sunset-conditions';

export const sunriseSunsetConditionDefinition: NodeDefinition = {
	type: 'sunriseSunsetCondition',
	category: 'condition',
	sourceHandles: ['true', 'false'],

	defaultData: () => ({
		label: 'Sunrise/Sunset',
		sunType: 'sunrise',
		beforeAfter: 'after',
		hours: 0,
		minutes: 0,
		locid: '',
	}),

	toSceneJson: (node: FlowNode) => {
		if (node.data.sceneData) {
			const sceneData = { ...(node.data.sceneData as any) };
			sceneData._fid = sceneData._fid || node.id;
			return sceneData;
		}
		if (node.data.originalCondition) {
			const original = { ...(node.data.originalCondition as any) };
			original._fid = original._fid || node.id;
			return original;
		}

		const sunType = (node.data.sunType as string) || 'sunrise';
		const result = createSunriseSunsetConditionFromFlow({
			type: sunType === 'sunset' ? 'sunset' : 'sunrise',
			beforeAfter: (node.data.beforeAfter as 'before' | 'after') || 'after',
			hours: Number(node.data.hours ?? 0),
			mins: Number(node.data.minutes ?? 0),
			locid: (node.data.locid as string) || '',
		});
		return { ...result, _fid: node.id };
	},
};
